/** @jsx h */

import { styleguide } from 'styleguide'
import styled, { css } from 'preact-emotion'
import { h } from 'preact'
import { springY, hash } from './utils'
import { Divider } from './components'

const rendered = css`
  pointer-events: auto;
  opacity: 1;
`
const ThankYou = styled('div')`
  position: absolute;
  left: 0;
  right: 0;
  padding: 0 ${styleguide.spacing.l} ${styleguide.spacing.l};
  color: ${styleguide.colors.text};
  transition: all 300ms ${styleguide.timingFuncs.ease};
  font-family: inherit;
  z-index: 4;
  opacity: 0;
  pointer-events: none;
  ${props => props.in && rendered};
  ${props => (props.springToY ? springY(props.springToY, 'softest') : null)};
  animation-delay: 20ms !important;
  transition-delay: 20ms !important;
`

const Emoji = styled('div')`
  display: table-cell;
  width: ${props => props.width * 0.22}px;
  font-size: 70px;
  vertical-align: middle;
  ${styleguide.mobile(
    css(`
      font-size: 40px;
    `)
  )};
`

const Message = styled('div')`
  display: table-cell;
  width: ${props => props.width * 0.75}px;
  padding-left: 10px;
  vertical-align: middle;
  font-size: 18px;
  color: ${styleguide.colors.widgetGray};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${styleguide.mobile(
    css(`
      font-size: 14px;
    `)
  )};
`

const Title = styled('p')`
  font-family: ${props => props.font};
  font-weight: ${props => props.weight};
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 8px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: ${styleguide.colors.text};
  ${styleguide.mobile(
    css(`
      font-size: 16px;
    `)
  )};
`

export const thankYouId = `scoops-${hash('thanks')}`
export default function({
  className,
  theme,
  message: { title, text, emoji = '🎊' },
  springToY,
  style,
  rendered,
  surveyWidth,
}) {
  return (
    <ThankYou
      id={thankYouId}
      in={rendered}
      springToY={springToY}
      style={{ transform: 0, ...style }}>
      <Divider
        css={`
          margin-bottom: ${styleguide.spacing.m};
        `}
      />
      <Emoji width={surveyWidth}>{emoji}</Emoji>
      <Message width={surveyWidth}>
        <Title font={theme.titleFont} weight={theme.titleWeight}>
          {title}
        </Title>
        <p> {text} </p>
      </Message>
    </ThankYou>
  )
}



// WEBPACK FOOTER //
// ../api/src/ThankYou.jsx